// import { useEffect } from "react";

// type GTranslateSettings = {
//   default_language: string;
//   detect_browser_language: boolean;
//   languages: string[];
//   wrapper_selector: string;
//   switcher_horizontal_position: string;
//   switcher_open_direction: string;
// };

// const GTranslate = () => {
//   useEffect(() => {
//     // Prevent duplicate script injection
//     const existingScript = document.getElementById("gtranslate-script");
//     if (existingScript) return;

//     const gWindow = window as Window & {
//       gtranslateSettings?: GTranslateSettings;
//     };

//     // Define settings BEFORE loading script
//     gWindow.gtranslateSettings = {
//       default_language: "en",
//       detect_browser_language: true,
//       languages: ["en", "fr", "ar", "pt"],
//       wrapper_selector: ".gtranslate_wrapper",
//       switcher_horizontal_position: "inline",
//       switcher_open_direction: "top",
//     };

//     const script = document.createElement("script");
//     script.id = "gtranslate-script";
//     script.src = "https://cdn.gtranslate.net/widgets/latest/dwf.js";
//     script.defer = true;

//     document.body.appendChild(script);
//   }, []);

//   return <div className="gtranslate_wrapper" />;
// };

// export default GTranslate;

// import { useEffect, useRef } from 'react';

// const GTranslate = () => {
//   const scriptRef = useRef(null);

//   useEffect(() => {
//     // 1. Check if script already exists to prevent duplicate injections
//     if (document.getElementById('gtranslate-script')) {
//       return;
//     }

//     // 2. Create the script element
//     const script = document.createElement('script');
//     script.id = 'gtranslate-script';
//     script.src = '//cdn.gtranslate.net/widgets/latest/dwf.js'; // Or the specific URL from your snippet
//     script.async = true;
    
//     // 3. Append the inline initialization code (from your GTranslate dashboard)
//     const inlineScript = document.createElement('script');
//     inlineScript.innerHTML = `
//       window.doGTranslate = function() {
//         // Paste the exact doGTranslate function body from your GTranslate snippet here
//         // Example: new GTranslate({ ... your config ... });
//       };
//       if (typeof jQuery !== "undefined") {
//         jQuery(document).ready(function() { doGTranslate(); });
//       } else {
//         window.addEventListener('load', doGTranslate);
//       }
//     `;

//     // 4. Append to the document body (or a specific container)
//     document.body.appendChild(script);
//     document.body.appendChild(inlineScript);
//     scriptRef.current = script;

//     // 5. Cleanup on unmount
//     return () => {
//       if (scriptRef.current) {
//         document.body.removeChild(scriptRef.current);
//       }
//       const inline = document.getElementById('gtranslate-inline');
//       if (inline) document.body.removeChild(inline);
      
//       // Optional: Remove GTranslate injected DOM elements if you want a clean unmount
//       const gtElements = document.querySelectorAll('.gtranslate_wrapper, .goog-te-banner-frame');
//       gtElements.forEach(el => el.remove());
//     };
//   }, []);

//   // This div is where GTranslate will render the dropdown/flags
//   return <div id="gtranslate_wrapper" className="gtranslate-container" />;
// };

// export default GTranslate;

// import { useEffect, useRef } from "react";

// const GTranslate = () => {
//   // 1. Create a ref for the outer "sacrificial" container
//   const containerRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     if (!containerRef.current) return;

//     // 2. GLOBAL SETUP: Inject script and settings ONLY ONCE per page load
//     // This prevents the script from being injected 4 times by StrictMode or multiple components
//     if (!document.getElementById("gtranslate-script")) {
//       const gWindow = window as any;
      
//       gWindow.gtranslateSettings = {
//         default_language: "en",
//         detect_browser_language: true,
//         languages: ["en", "fr", "ar", "pt"],
//         wrapper_selector: ".gtranslate_wrapper",
//         switcher_horizontal_position: "inline",
//         switcher_open_direction: "top",
//       };

//       const script = document.createElement("script");
//       script.id = "gtranslate-script";
//       script.src = "https://cdn.gtranslate.net/widgets/latest/dwf.js";
//       script.async = true;
//       document.body.appendChild(script);
//     }

//     // 3. LOCAL SETUP: Create the wrapper for THIS specific component instance
//     // We check if it already exists to prevent duplicates during React StrictMode re-runs
//     if (!containerRef.current.querySelector(".gtranslate_wrapper")) {
//       const wrapper = document.createElement("div");
//       wrapper.className = "gtranslate_wrapper";
//       containerRef.current.appendChild(wrapper);
//     }

//     // 4. CLEANUP: When the component unmounts, clear the container.
//     // We DO NOT remove the script or global settings, as they are shared globally.
//     return () => {
//       if (containerRef.current) {
//         containerRef.current.innerHTML = "";
//       }
//     };
//   }, []);

//   // CRITICAL: We return ONLY the outer container. 
//   // React manages this div, but its children are managed by vanilla JS/GTranslate.
//   // This completely prevents the "Failed to execute 'removeChild'" crash.
//   return <div ref={containerRef} className="gtranslate-outer-wrapper" />;
// };

// export default GTranslate;

import { loadGTranslate } from "@/utils/helpers/loadGTranslate";
import { useEffect } from "react";

const GTranslate = () => {
  useEffect(() => {
    loadGTranslate();
  }, []);

  return <div className="gtranslate_wrapper" />;
};

export default GTranslate;